import React from 'react';

interface ThinkingIndicatorProps {
  /** Status line from NDJSON stream (defaults to animated "Thinking…"). */
  label?: string | null;
}

/**
 * Animated loading label shown while the LangGraph chat agent is working.
 */
const ThinkingIndicator: React.FC<ThinkingIndicatorProps> = ({ label }) => {
  const base = (label ?? 'Thinking…').replace(/\.{3}|…$/u, '').trim() || 'Thinking';

  return (
    <span className="chat-thinking-indicator" aria-live="polite">
      <span className="chat-thinking-shimmer" aria-hidden="true" />
      <span className="chat-thinking-label">{base}</span>
      <span className="chat-thinking-dots" aria-hidden="true">
        <span>.</span>
        <span>.</span>
        <span>.</span>
      </span>
    </span>
  );
};

export default ThinkingIndicator;
